import Component from "../../lib/Component.js";
import { createBottomSheet } from "./BottomSheet.js";
import { fetchJustWatchData } from "./JustWatchAPI.js";

const JustWatchButton = (options) => {
  const renderOfferList = (type, offers) => {
    if (!offers || offers.length === 0) return "";
    return `
      <div class="offer-section">
        <h4>${type}</h4>
        <div class="justwatch-offers-list">
          <div class="justwatch-prtesentation-types">
            <div></div>
            <div>SD</div>
            <div>HD</div>
            <div>4K</div>
          </div>
          ${offers
            .map(
              (offer) => `
              <div class="justwatch-offer-item-row">
                <div class="justwatch-provider-info">
                  <img src="${offer.provider.icon_url}" alt="${offer.provider.clear_name}" />
                  <span>${offer.provider.clear_name}</span>
                </div>
                ${["sd", "hd", "4k"]
                  .map((quality) => {
                    return `<div class="justwatch-offer-item">
                      ${
                        offer.offers[quality]
                          ? `<a href="${offer.offers[quality].urls.standard_web}" target="_blank" class="justwatch-offer-item">
                        ${offer.offers[quality].retail_price ? `<span>${offer.offers[quality].retail_price} ${offer.offers[quality].currency}</span>` : "<i class='fas fa-play'></i>"}
                      </a>`
                          : "<span class='not-available'><i class='fas fa-times'></i></span>"
                      }
                    </div>`;
                  })
                  .join("")}
                </div>`
            )
            .join("")}
        </div>
      </div>
    `;
  };

  const mapOffersByPresentationType = (offers) => {
    const tieredOffers = offers.reduce((tieredOffers, offer) => {
      if (!tieredOffers[offer.monetization_type]) {
        tieredOffers[offer.monetization_type] = {};
      }
      if (!tieredOffers[offer.monetization_type][offer.provider.technical_name]) {
        tieredOffers[offer.monetization_type][offer.provider.technical_name] = {
          provider: offer.provider,
          offers: {},
        };
      }
      tieredOffers[offer.monetization_type][offer.provider.technical_name].offers[offer.presentation_type] = offer;
      return tieredOffers;
    }, {});

    const sortProviders = (providers, priority) => {
      const sortedProviders = Object.values(providers).sort((a, b) => {
        const aPriority = priority(a.provider);
        const bPriority = priority(b.provider);
        return aPriority - bPriority;
      });
      return sortedProviders.reduce((acc, provider) => {
        acc[provider.provider.technical_name] = provider;
        return acc;
      }, {});
    };

    // Prioritize providers based on the defined order
    const providerPriorities = ["netflix", "max", "disneyplus", "amazonprimevideo", "skyshowtime"];
    if (tieredOffers["flatrate"]) {
      tieredOffers["flatrate"] = sortProviders(tieredOffers["flatrate"], (provider) => {
        return providerPriorities.indexOf(provider.technical_name);
      });
    }
    if (tieredOffers["rent"]) {
      tieredOffers["rent"] = sortProviders(tieredOffers["rent"], (provider) => {
        return provider.id;
      });
    }
    if (tieredOffers["buy"]) {
      tieredOffers["buy"] = sortProviders(tieredOffers["buy"], (provider) => {
        return provider.id;
      });
    }

    return tieredOffers;
  };

  const justwatchOffersBottomSheet = createBottomSheet("justwatch-offers-dialog", {
    header: true,
    scrollBody: true,
    onOpen: async (data, tieredOffers) => {
      // Skip rendering if no data provided (empty state handles its own content)
      if (!data || !tieredOffers) {
        return;
      }

      justwatchOffersBottomSheet.setHeader("Hol nézheted online?");
      justwatchOffersBottomSheet.setContent(`
        ${renderOfferList("Streamelés", Object.values(tieredOffers["flatrate"] || {}))}
        ${renderOfferList("Kölcsönzés", Object.values(tieredOffers["rent"] || {}))}
        ${renderOfferList("Vásárlás", Object.values(tieredOffers["buy"] || {}))}
        <div class="justwatch-branding">
          <a class="branding"
              target="_blank" 
              rel="noopener" 
              href="https://www.justwatch.com${data.full_path}"
              data-original="https://www.justwatch.com">
              Streaming information by 
              <span class="logo">
                  <span class="sr-only">JustWatch</span>
              </span>
          </a>
        </div>
      `);
    },
  });

  const createStreamingButton = async (movieId) => {
    const data = await fetchJustWatchData("internal", movieId);
    if (!data || !data.offers || data.offers.length === 0) {
      return null;
    }

    const tieredOffers = mapOffersByPresentationType(data.offers);

    let selectedProvider;
    if (tieredOffers["flatrate"]) {
      selectedProvider = Object.values(tieredOffers["flatrate"])[0].provider;
    } else if (tieredOffers["rent"]) {
      selectedProvider = Object.values(tieredOffers["rent"])[0].provider;
    } else if (tieredOffers["buy"]) {
      selectedProvider = Object.values(tieredOffers["buy"])[0].provider;
    }

    if (!selectedProvider) {
      return null;
    }

    return { data, selectedProvider, tieredOffers };
  };

  let streamingButton;
  if (options.streamingButton) {
    streamingButton = options.streamingButton;
  } else {
    streamingButton = document.createElement("button");
    streamingButton.className = "button streaming loading";
    streamingButton.innerHTML = `
        <i class="fas fa-circle-notch fa-spin loading-icon"></i>
        <i class="fas fa-times disabled-icon"></i>
        <img src="/pixel.gif" alt="" />
        <span>Nézd online<br><span class="by-justwatch">by JustWatch</span></span>
      `;
  }

  return new Component({
    componentName: "JustWatchButton",
    onMount: async () => {
      if (options && options.onMount) {
        options.onMount(streamingButton);
      }

      const most = new Date().getTime();
      const from = new Date("2026-04-03 19:00").getTime();
      const to = new Date("2026-04-05 23:59").getTime();
      if (options.movieId === "7147" && most >= from && most <= to) {
        streamingButton.classList.remove("loading");
        streamingButton.addEventListener("click", () => {
          window.open("https://www.eletedmozija.hu/", "_blank");
        });
        streamingButton.querySelector("img").src =
          "https://static.wixstatic.com/media/aea68d_59248cbf57e040849ef98d63f6d3dd20~mv2.png/v1/crop/x_0,y_78,w_2908,h_2947/fill/w_980,h_993,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/csillag-png-eletedmozija_4x.png";
        streamingButton.querySelector("img").alt = "életedmozija.hu";
        streamingButton.title = `Nézd online itt: életedmozija.hu`;
        streamingButton.querySelector("span").innerHTML =
          `Nézd online<br><span class="by-justwatch">by életedmozija.hu</span>`;
        return;
      }

      const result = await createStreamingButton(options.movieId);
      streamingButton.classList.remove("loading");
      if (!result) {
        streamingButton.classList.add("disabled");
        // Allow clicks on disabled button to show empty state
        streamingButton.addEventListener("click", () => {
          justwatchOffersBottomSheet.setHeader("Hol nézheted online?");
          justwatchOffersBottomSheet.setContent(`
            <div class="empty-state" style="padding: 24px; text-align: center; color: var(--theme-text-color);">
              <p style="font-size: 1.5rem; margin-bottom: 16px;"><i class="fa-solid fa-tv"></i></p>
              <p style="margin-bottom: 12px;">Jelenleg nem érhető el online ez a film Magyarországon.</p>
              <p style="font-size: 0.9rem; opacity: 0.8;">Gyere vissza később!</p>
            </div>
            <div class="justwatch-branding" style="margin-top: 16px;">
              <a class="branding"
                  target="_blank" 
                  rel="noopener" 
                  href="https://www.justwatch.com/hu"
                  data-original="https://www.justwatch.com">
                  Streaming information by 
                  <span class="logo">
                      <span class="sr-only">JustWatch</span>
                  </span>
              </a>
            </div>
          `);
          justwatchOffersBottomSheet.open();
        });
        justwatchOffersBottomSheet.mount();
      } else {
        const { data, selectedProvider, tieredOffers } = result;
        streamingButton.addEventListener("click", () => {
          justwatchOffersBottomSheet.open(data, tieredOffers);
        });
        streamingButton.querySelector("img").src = selectedProvider.icon_url;
        streamingButton.querySelector("img").alt = selectedProvider.clear_name;
        streamingButton.title = `Nézd online itt: ${selectedProvider.clear_name} (by JustWatch)`;

        justwatchOffersBottomSheet.mount();
      }
    },
    onUnmount: async () => {
      justwatchOffersBottomSheet.unmount();
      if (options && options.onUnmount) {
        options.onUnmount();
      }
    },
  });
};

export default JustWatchButton;
